export default "__VITE_ASSET__CtjB3Twm__"